/**
 * Site-wide SEO defaults. Used by useSeo() when a view doesn't override a
 * field, and by the JSON-LD generator. Change PUBLIC_URL via the
 * VUE_APP_PUBLIC_URL env var per environment (dev/staging/prod).
 */
export const SITE_NAME = 'We Search Research'
export const SITE_LEGAL_NAME = 'We Search Research Inc.'
export const PUBLIC_URL = (process.env.VUE_APP_PUBLIC_URL || 'https://wesearchresearch.net').replace(/\/$/, '')
export const DEFAULT_OG_IMAGE = `${PUBLIC_URL}/og-image.png`
export const DEFAULT_DESCRIPTION =
  'We Search Research helps patients and caregivers discover clinical trials, check if they may qualify, and connect with research teams — through a free, secure AI search assistant.'
export const TITLE_SUFFIX = ` | ${SITE_NAME}`
